export const bikeTypes = [
  { value: 999, label: "Autre type" },
  { value: 1, label: "Course/route/piste/triathlon" },
  { value: 2, label: "Gravel/Randonneuse/Cyclo Cross" },
  { value: 3, label: "VTT Adulte" },
  { value: 4, label: "VTC" },
  { value: 5, label: "Ville" },
  { value: 6, label: "Vélo enfant" },
  { value: 7, label: "Vélo pliant" },
  { value: 8, label: "Vélo cargo / long-tail et porteur (charge sur porte bagage avant et arrière)" },
  { value: 9, label: "Tricycle adulte" },
  { value: 10, label: "Tandem" },
  { value: 11, label: "Vélo couché" },
  { value: 12, label: "BMX" },
  { value: 13, label: "Autres type d'engin" },
  { value: 14, label: "Engin de déplacement personnel (trottinette)" },
  { value: 15, label: "Remorque" },
  { value: 16, label: "Vélo cargo / bi-porteur personne (charge sur châssis à l'avant)" },
  { value: 17, label: "Vélo cargo / bi-porteur utilitaire (charge sur châssis à l'avant)" },
  { value: 18, label: "Vélo cargo / triporteur et tricycle (2 roues avant ou 2 roues arrière)" },
]